module.exports = __webpack_public_path__ + "static/dashboard_traffic-527d903d3da3b817f16e25c4d578b25f.png";